document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll(".session__select-list > li > a");

    links.forEach(function (link) {
        link.addEventListener("click", function (event) {
            event.preventDefault();

            links.forEach(function (item) {
                item.classList.remove("active");
            });

            link.classList.add("active");

            const area = link.getAttribute("data-area");

            const mapItems = document.querySelectorAll(".session__map-item");
            mapItems.forEach(function (mapItem) {
                const mapArea = mapItem.getAttribute("data-area");
                if (mapArea === area) {
                    mapItem.classList.add("active");
                    const placeholder = document.querySelector(".session__map-placeholder");
                    placeholder.classList.add("hidden");
                } else {
                    mapItem.classList.remove("active");
                }
            });

            const eventBlocks = document.querySelectorAll(".session__events .card-event");
            eventBlocks.forEach(function (eventBlock) {
                const eventArea = eventBlock.getAttribute("data-area");
                if (eventArea === area) {
                    eventBlock.classList.add("active");
                } else {
                    eventBlock.classList.remove("active");
                }
            });
        });
    });
});

